import { Link } from "react-router-dom";
import { SignOutButton } from "@clerk/react";
import { BarChart3, Building, Ticket, Target, ScrollText, Globe } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useMe } from "@/lib/me";
import Overview from "@/pages/console/Overview";
import Customers from "@/pages/console/Customers";
import Vouchers from "@/pages/console/Vouchers";
import Leads from "@/pages/console/Leads";
import Compliance from "@/pages/console/Compliance";
import SiteSettings from "@/pages/console/SiteSettings";

const TABS = [
  ["overview", "Overview", BarChart3, Overview],
  ["customers", "Customers", Building, Customers],
  ["vouchers", "Vouchers", Ticket, Vouchers],
  ["leads", "Leads", Target, Leads],
  ["compliance", "Compliance & ops", ScrollText, Compliance],
  ["site", "Website & company", Globe, SiteSettings],
];

export default function ConsolePage() {
  const me = useMe();
  return (
    <div className="min-h-screen bg-[#F6F6F2]" data-testid="console-page">
      <header className="sticky top-0 z-30 border-b border-slate-200 bg-white/85 backdrop-blur-md">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-5 py-4">
          <div className="flex items-center gap-3">
            <img src="/icon.svg" alt="" className="h-8 w-8" />
            <div className="leading-tight">
              <p className="font-display font-extrabold">Back office</p>
              <p className="text-xs text-slate-500" data-testid="console-admin-email">{me.email}</p>
            </div>
          </div>
          <div className="flex items-center gap-4 text-sm font-semibold">
            {me.org && <Link to="/" className="text-slate-600 hover:text-slate-900" data-testid="console-open-app">Open pharmacy app</Link>}
            <SignOutButton><button className="text-slate-500" data-testid="console-signout">Sign out</button></SignOutButton>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-5 py-8">
        <Tabs defaultValue="overview">
          <TabsList className="mb-6 flex h-auto flex-wrap justify-start">
            {TABS.map(([v, l, I]) => <TabsTrigger key={v} value={v} data-testid={`console-tab-${v}`}><I className="mr-1.5 h-4 w-4" />{l}</TabsTrigger>)}
          </TabsList>
          {TABS.map(([v, , , C]) => <TabsContent key={v} value={v}><C /></TabsContent>)}
        </Tabs>
      </main>
    </div>
  );
}
